import { useContext } from 'react'

import { type AuthState, CurrentUserContext } from '../providers/CurrentUserContext'

export type { AuthState } from '../providers/CurrentUserContext'

export function useAuth(): AuthState {
  const state = useContext(CurrentUserContext)
  if (!state) {
    throw new Error('useAuth must be used within CurrentUserProvider')
  }

  return state
}

export function hasSpecificRoles(userRoles: string[], requiredRoles: string[]): boolean {
  return requiredRoles.some((role) => userRoles.includes(role))
}
